import { render, staticRenderFns } from "./ConsiderationsDocuments.vue?vue&type=template&id=604aeb5f&scoped=true&"
import script from "./ConsiderationsDocuments.vue?vue&type=script&lang=js&"
export * from "./ConsiderationsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ConsiderationsDocuments.vue?vue&type=style&index=0&id=604aeb5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604aeb5f",
  null
  
)

export default component.exports